<template>
  <div>
    <Navbar></Navbar>
    <div class="content">
      <div class="section_1">
        <div class="_t title">
          <p>More than an ECG</p>
          <p>monitor</p>
        </div>
        <div class="_p">Heart Smart™ , the ultimate ECG monitor combining high accuracy HRV measurement with advanced analysis. This sleek and compact device revolutionizes heart health
monitoring, providing precise insights in a fingertip size,
allowing you to understand your body's response to stress and assess overall well-being. With Heart Smart™ , you can upload data to our secure center and unlock advanced analysis capabilities. Expert algorithms analyze your ECG data, detecting arrhythmias and providing comprehensive stress analysis. Accessible to fitness enthusiasts,
health-conscious individuals, and those managing cardiac conditions,Heart Smart™ 's user-friendly interface and
intuitive operation make it a convenient and reliable choice.</div>
      <div class="img">
        <img src="@/assets/2.0/mobile/icon_group_2.png" />
      </div>
      </div>

      <div class="section_2">
        <div class="img">
          <img src="@/assets/2.0/mobile/h_section_bg.png" />
        </div>
      </div>
      <div class="section_3">
        <div class="_t title">
          <p style="position: relative;"><span>Heart Smart</span><span style="font-size: 0.36rem;position: absolute;top: 0.1rem;">™</span> <span style="padding-left: 0.2rem;">is built</span></p>
          <p>with lighter weight and</p>
          <p>better performance</p>
        </div>
        <div class="img">
          <img src="@/assets/2.0/mobile/icon_group_3.png" />
        </div>
      </div>
      <div class="section_4">
        <div class="img">
          <img src="@/assets/2.0/mobile/table_2.png" />
        </div>
      </div>
      <div class="section_5">
        <div class="c-box">
        <div class="">
          <div class="c-title" :class="{'active': active ===1 }" @click="tabClick(1)">
            <div class="text-bg">WHAT IS ARRGYTHMIAS? </div>
            <div class="icon">
              <img class="_bottom" src="@/assets/2.0/arrow-bottom.png">
              <img class="_top" src="@/assets/2.0/arrow-top.png">
            </div>
          </div>
          <div class="c-title" :class="{'active': active ===2 }" @click="tabClick(2)">
            <div class="text-bg">WHAT IS HEART RATE VARIABILITY (HRV) ? </div>
            <div class="icon">
              <img class="_bottom" src="@/assets/2.0/arrow-bottom.png">
              <img class="_top" src="@/assets/2.0/arrow-top.png">
            </div>
          </div>
        </div>
        <div class="text-box">
          <p v-for="(item,index) in arr" :key="index">{{ item }}</p>
        </div>
      </div>
      </div>
    </div>
    <FooterDom></FooterDom>
  </div>
</template>

<script>
import Navbar from "./components/navbar.vue";
import FooterDom from "./components/footerEle.vue";


export default {
  name: "index",
  components: { Navbar,FooterDom },
  data() {
    return {
      arr: [
        "Arrhythmias are abnormalities in the rhythm of the heartbeat. Our hearts have their own electrical system that regulates the timing and coordination of the heartbeats. This system ensures that the heart contracts and relaxes in a regular pattern, allowing blood to be pumped effectively throughout the body. However, in the case of arrhythmias, there is a disruption in this electrical system, leading to irregular heart rhythms.",
        "Arrhythmias can manifest in different ways, ranging from occasional skipped or extra beats to more severe and persistent irregular rhythms. But people may not even notice their arrhythmias, which is why it is important to early detect the potential risk and consult a healthcare professional. ",
        "An electrocardiogram (ECG) is a commonly used test that can help detect and diagnose arrhythmias. It measures the electrical activity of the heart by detecting the electrical signals (impulses or waves) from the heart through electrodes attached on the body. Although some smart watches or fitness bands are built with ECG function, they are not replaceable of accurate ECG monitors for diagnosis purpose."
      ],
      arrText: [
        "Arrhythmias are abnormalities in the rhythm of the heartbeat. Our hearts have their own electrical system that regulates the timing and coordination of the heartbeats. This system ensures that the heart contracts and relaxes in a regular pattern, allowing blood to be pumped effectively throughout the body. However, in the case of arrhythmias, there is a disruption in this electrical system, leading to irregular heart rhythms.",
        "Arrhythmias can manifest in different ways, ranging from occasional skipped or extra beats to more severe and persistent irregular rhythms. But people may not even notice their arrhythmias, which is why it is important to early detect the potential risk and consult a healthcare professional. ",
        "An electrocardiogram (ECG) is a commonly used test that can help detect and diagnose arrhythmias. It measures the electrical activity of the heart by detecting the electrical signals (impulses or waves) from the heart through electrodes attached on the body. Although some smart watches or fitness bands are built with ECG function, they are not replaceable of accurate ECG monitors for diagnosis purpose."
      ],
      hrvText: [
        "Heart rate variability (HRV) refers to the variation in time intervals between successive heartbeats. In simpler terms, it measures the changes in the timing between each heartbeat.",
        "HRV is influenced by the balance between the sympathetic and parasympathetic branches of the autonomic nervous system.",
        "Studies have shown that increased stress levels are associated with decreased HRV. When we experience stress, the sympathetic nervous system becomes more dominant, leading to a decrease in HRV. Conversely, when we are in a relaxed state, the parasympathetic nervous system becomes more active, resulting in increased HRV. A higher HRV indicates that the body is better able to adapt and respond to changing conditions. Monitoring HRV can provide lots of insights into our body's response to stress.",
      ],
      active:1,
    };
  },
  created() {

  },
  computed: {

  },
  mounted() {

  },
  methods: {
    tabClick(row){
      this.active = row;
      this.arr = row === 1 ? this.arrText : this.hrvText;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  font-size: 0;
  ._t {
    font-size: 0.7rem;
    color: #000;
  }
  ._p{
    font-size: 0.22rem;
    color: #000;
  }
  .img{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .section_1{
    background: #fff;
    padding: 0.78rem;
    width: 100%;
    ._p{
      margin: 0.78rem 0;
      line-height: 0.4rem;
    }
    .img{

    }

  }

  .section_3{
    background: #fff;
    padding: 0.78rem 0.78rem 0;
    width: 100%;
    .title{
      font-size: 0.6rem;
    }
    .img{
      margin-top: 0.4rem;
      width: 4.2rem;
      margin-left: 1.4rem;
    }
  }
  .section_4{
    padding: 0.24rem 0.54rem 0.54rem;
  }
  .section_5{
    background: #eaeaea;
    padding: 0.54rem;
    ._p{
      margin-top: 0.2rem;
    }
    .img{
      margin-top: 0.8rem;
    }
    .c-box{

    .text-box{
      background: #fff;
      padding: 0.54rem;
      width: 100%;
      margin-top: 0.2rem;
      font-size: 0.24rem;
      p{
        margin-bottom: 0.3rem;
      }
    }
  }
  .c-title{
    width: 100%;
    color: #000;
    font-size: 0.28rem;
    margin-bottom: 0.2rem;
    height: 0.64rem;
    line-height: 0.64rem;
    transition: all 0.2s;
    display: flex;
    cursor: pointer;
    overflow: hidden; //超出的文本隐藏
text-overflow: ellipsis; //溢出用省略号显示
white-space: nowrap;  // 默认不换行；

    &:hover{
      .text-bg{
        background: #79e7b0;
        color: #fff;

      }
      .icon{
        background: #79e7b0;
      }
    }
    .text-bg{
      background: #fff;
      padding: 0 30px;
      width: 100%;
      overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: "Light";
    }
    &:last-child{
      margin-right: 0;
    }
    .icon{
      margin-left: 0.05rem;
      background: #fff;
      height: 0.64rem;
      width: 0.60rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      ._top{
        width: 0.15rem;
        height: 0.09rem;
        display: none;
      }
      ._bottom{
        width: 0.14rem;
        height: 0.09rem;
        display: block;
      }
    }
    &.active{
      color: #fff;
      .text-bg{
      background: #50C88C;
    }
      .icon{
        background: #50C88C;
        ._top{
        display: block;
      }
      ._bottom{
        display: none;
      }
      }
    }
  }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/mobile/howHeart.vue